import { Grid, Paper } from '@mui/material';
// import { useState } from 'react';
import TrendsChart from './TrendsViewCharts/Trendchart';
import CameraHeatmapViewer from './CameraHeatmapViewer';
import FloorToggle from './FloorToggle';
import { useState } from 'react';

const LineChartToggle = () => {
  const [activeButton, setActiveButton] = useState('Trends View');

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const currentDate = new Date();
  const currentDay = currentDate.getDay();
  const startOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
  startOfWeek.setDate(currentDate.getDate() - currentDay - 3);
  const endOfWeek = new Date(currentDate.setUTCHours(0, 0, 0, 0));
  endOfWeek.setDate(currentDate.getDate() + 2);

  return (
    <Grid item sx={{ maxWidth: '100%', maxHeight: '100%', height: 'auto' }}>
      <Paper
        elevation={3}
        sx={{
          width: '100%',
          height: 'auto',
          padding: '20px',
          marginBottom: '20px',
          position: 'relative',
          left: 'auto',
          borderRadius: '15px'
        }}
      >

       <button
            onClick={() => handleButtonClick('Trends View')}
            // style={{
            //   backgroundColor: activeButton === 'Trends View' ? 'black' : 'gray',
            //   color: '#fff',
            //   padding: '4px',
            //   borderRadius: '17px 0 0 17px',
            //   marginRight: '3px',
            //   width: '15%',
            //   fontSize: '1rem',
            //   cursor: 'pointer'
            // }}
          >
            {/* Trends View */}
          </button>
        {/* <div style={{ padding: '2px', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1%' }}>
          <button
            onClick={() => handleButtonClick('Trends View')}
            style={{
              backgroundColor: activeButton === 'Trends View' ? 'black' : 'gray',
              color: '#fff',
              padding: '4px',
              borderRadius: '17px 0 0 17px',
              marginRight: '3px',
              width: '15%',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            Trends View
          </button>
          <button
            onClick={() => handleButtonClick('Store View')}
            style={{
              backgroundColor: activeButton === 'Store View' ? 'black' : 'gray',
              color: '#fff',
              padding: '4px',
              marginRight: '3px',
              width: '15%',
              fontSize: '1rem',
            }}
          >
            Map View
          </button>
          <button
            // disabled
            onClick={() => handleButtonClick('Camera View')}
            style={{
              backgroundColor: activeButton === 'Camera View' ? 'black' : 'gray',
              color: '#fff',
              padding: '4px',
              borderRadius: '0 17px 17px 0',
              width: '15%',
              fontSize: '1rem',
            }}
          >
            Camera view
          </button>
        </div> */}

        {activeButton === 'Trends View' ? (
          <div style={{ width: '100%', overflow: 'auto', height: '570px' }}>
            <TrendsChart />
          </div>
        ) : activeButton === 'Camera View' ? (
          <div className='w-full h-full overflow-auto' >
            <CameraHeatmapViewer />
          </div>
        ) : (
          <div style={{ position: 'relative', width: '100%', height: '570px', overflow: 'auto' }}>
            <FloorToggle />
          </div>
        )}
      </Paper>
    </Grid>
  );
};

export default LineChartToggle;
